import axios from "axios";
import { LABELS, MONTHS } from "../constants/constants";

export const getTitleHelper = ({
  keyword = "",
  gLocation = "UK",
}: {
  keyword?: string | string[];
  gLocation?: string | string[];
}) => {
  if (Array.isArray(keyword)) keyword = keyword.join();
  if (Array.isArray(gLocation)) gLocation = gLocation.join();

  let keywordParse = toCapitalizeCase(keyword.replace(/[\W_]+/g, " ")).replace(
    "Jobs",
    ""
  );

  keywordParse = keywordParse.replace(/jobs|[^A-Za-z\s+]/g, "");

  const locationParse = toCapitalizeCase(gLocation);
  const country =
    gLocation !== LABELS.JOBS_TITLE_PART_3
      ? ", " + LABELS.JOBS_TITLE_PART_3
      : "";

  const dateObj = new Date();
  const month = dateObj.getMonth();
  const year = dateObj.getFullYear();

  const monthName = MONTHS[month];

  return `${keywordParse} ${LABELS.JOBS_TITLE_PART_2} ${locationParse}${country} ${LABELS.JOBS_TITLE_PART_4} ${monthName} ${year}`;
};

export const toCapitalizeCase = (str: string): string => {
  return str.replace(/(?:^|\s|-)\S/g, (match) => {
    return match.replace(/-/g, " ").toUpperCase();
  });
};

export const fetchData = async ({ keyword, xlocation, adv }: any) => {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_JOB_API_BASE_URL}jobs/`,
    {
      params: {
        keyword,
        location: xlocation,
        adv,
      },
    }
  );
  return response.data;
};

export const fetchGoogleLocation = async (
  id: string | string[] | undefined
) => {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_JOB_API_BASE_URL}get_id?loc_id=${id}`
  );

  return response.data;
};

export const gtmPushDataLayer = (data: { [x: string]: any }) => {
  window.dataLayer?.push({
    ...data,
  });
};
